import { Injectable, inject } from '@angular/core';
import { Observable, map, switchMap } from 'rxjs';

import { IglesiasService } from '../../core/services/iglesias.service';
import { SolicitudesService } from '../../core/services/solicitudes.service';
import { ChatConversacion } from '../../shared/interfaces/chat.interface';
import { CelulaDataSource } from './celula-data-source';
import { CelulaContexto, CelulaPedidoTipo } from './celula.model';

@Injectable()
export class CelulaService extends CelulaDataSource {
  private readonly solicitudes = inject(SolicitudesService);
  private readonly iglesias = inject(IglesiasService);

  contexto(): Observable<CelulaContexto> {
    return this.iglesias.getCurrentIglesia().pipe(
      map((iglesia) => ({
        setLevel: iglesia.setLevel ?? 0,
        cantCulto: iglesia.cantCulto ?? 0,
      })),
    );
  }

  listar(): Observable<ChatConversacion[]> {
    return this.solicitudes.listarCelula();
  }

  enviarMensaje(personaId: string, nota: string): Observable<ChatConversacion[]> {
    return this.solicitudes.enviarMensajeCelula(personaId, nota);
  }

  marcarLeidos(personaId: string): Observable<ChatConversacion[]> {
    return this.solicitudes.marcarLeidosCelula(personaId);
  }

  crearSolicitud(
    personaId: string,
    tipo: CelulaPedidoTipo,
    motivo: string,
  ): Observable<ChatConversacion[]> {
    const pedido =
      tipo === 'bajaBautismo'
        ? this.solicitudes.crearBajaBautismo(personaId, motivo)
        : this.solicitudes.crearSolicitud(personaId, tipo, motivo);

    return pedido.pipe(switchMap(() => this.solicitudes.listarCelula(true)));
  }
}
